module.exports = __webpack_public_path__ + "img/header-wallet-bg.e6b1d7dd.png";